export const MATRIX_INDICATOR =
{
    MatrixId: 1,
    ModuleId: 2,
    FeatureId: 3,
    CategoryId: 4,
    LoginTypeId: 5
}

export const LOGIN_TYPE =
{
    Internal: 1,
    External: 2,
    Login: 3
}

export const CATEGORY =
{
    BurgerMenuInternal: 1,
    Invoice: 2,
    Order: 3,
    Quotation: 4,
    HomeDashboard: 5,
    RequestDashboard: 6,
    ReportDashboard: 7,
    BurgerMenuExternal: 8,
    Login: 9,
    InventoryExternal: 10
}

export const FEATURES =
{
    Administration: 1,
    Reporting: 2,
    FinanceManager: 3,
    InventoryManager: 4,
    LanguageSetting: 5,
    LogOff: 6,
    InvoiceDashboard: 7,
    InvoiceManagementPage: 8,
    OrderDashboard: 9,
    OrderManagementPage: 10,
    QuotationDashboard: 11,
    QuotationManagementPage: 12,
    PersonalDashboard: 13,
    MyDirectReportsDashboard: 14,
    MyRequests: 15,
    ForApproval: 16,
    QuotationRequests: 17,
    MyCoverage: 18,
    Reports: 19,
    UserGuide: 20,
    LogOut: 21,
    Login: 22,
    Circuit: 23,
    Equipment: 24,
    ASPU: 25,
    ASR: 26
}

export const MODULES =
{
    ManagedUsers: 1,
    ManagedCSATSurvey: 2,
    UserAccess: 3,
    UserRoles: 4,
    ReportingInternal: 5,
    Vendor: 6,
    ContractPage: 7,
    CataloguePage: 8,
    AccountPage: 9,
    InvoiceUpload: 10,
    ChargeMapping: 11,
    CreateInvoice: 12,
    InvoiceCalendar: 13,
    CDRUpload: 14,
    AccountsPayable: 15,
    RateCard: 16,
    DisputePage: 17,
    RateCataloguePage: 18,
    RatePlanOptimization: 19,
    CostCenterPage: 20,
    GLCodePage: 21,
    CurrencyPage: 22,
    InventoryManager: 23,
    LanguageSetting: 24,
    LogOff: 25,
    InvoiceDashboard: 26,
    InvoiceManagementPage: 27,
    OrderDashboard: 28,
    OrderManagementPage: 29,
    QuotationDashboard: 30,
    QuotationManagementPage: 31,
    PersonalDashboard: 32,
    MyDirectReportsDashboard: 33,
    MyRequests: 34,
    ForApproval: 35,
    QuotationRequests: 36,
    MyCoverage: 37,
    Reports: 38,
    UserGuide: 39,
    LogOut: 40,
    Login: 41,
    InventoryCircuit: 42,
    InventoryEquipment: 43,
    InventoryASPU: 44,
    InventoryASR: 45
}

export const ACCESS_MODULE =
{
    ManagedUsersR: 1,
    ManagedUsersRE: 2,
    ManagedUsersRW: 3,
    ManagedCSATSurveyR: 4,
    ManagedCSATSurveyRE: 5,
    ManagedCSATSurveyRW: 6,
    UserAccessR: 7,
    UserAccessRE: 8,
    UserAccessRW: 9,
    UserRolesR: 10,
    UserRolesRE: 11,
    UserRolesRW: 12,
    ReportingInternalR: 13,
    ReportingInternalRE: 14,
    ReportingInternalRW: 15,
    VendorR: 16,
    VendorRE: 17,
    VendorRW: 18,
    ContractPageR: 19,
    ContractPageRE: 20,
    ContractPageRW: 21,
    CataloguePageR: 22,
    CataloguePageRE: 23,
    CataloguePageRW: 24,
    AccountPageR: 25,
    AccountPageRE: 26,
    AccountPageRW: 27,
    InvoiceUploadR: 28,
    InvoiceUploadRE: 29,
    InvoiceUploadRW: 30,
    ChargeMappingR: 31,
    ChargeMappingRE: 32, 
    ChargeMappingRW: 33,
    CreateInvoiceR: 34,
    CreateInvoiceRE: 35,
    CreateInvoiceRW: 36,
    InvoiceCalendarR: 37,
    InvoiceCalendarRE: 38,
    InvoiceCalendarRW: 39,
    CDRUploadR: 40,
    CDRUploadRE: 41,
    CDRUploadRW: 42,
    AccountsPayableR: 43,
    AccountsPayableRE: 44,
    AccountsPayableRW: 45,
    InvoiceRateCardR: 46,
    InvoiceRateCardRE: 47,
    InvoiceRateCardRW: 48,
    DisputePageR: 49,
    DisputePageRE: 50,
    DisputePageRW: 51,
    RateCataloguePageR: 52,
    RateCataloguePageRE: 53,
    RateCataloguePageRW: 54,
    RatePlanOptimizationR: 55,
    RatePlanOptimizationRE: 56,
    RatePlanOptimizationRW: 57,
    CostCenterPageR: 58,
    CostCenterPageRE: 59,
    CostCenterPageRW: 60,
    GLCodePageR: 61,
    GLCodePageRE: 62,
    GLCodePageRW: 63,
    CurrencyPageR: 64,
    CurrencyPageRE: 65,
    CurrencyPageRW: 66,
    InventoryManagerR: 67,
    InventoryManagerRE: 68,
    InventoryManagerRW: 69,
    LanguageSettingRW: 70,
    LogOffRW: 71,
    InvoiceDashboardR: 72,
    InvoiceDashboardRE: 73,
    InvoiceDashboardRW: 74,
    InvoiceManagementPageR: 75,
    InvoiceManagementPageRE: 76,
    InvoiceManagementPageRW: 77,
    OrderDashboardR: 78,
    OrderDashboardRE: 79,
    OrderDashboardRW: 80,
    OrderManagementPageR: 81,
    OrderManagementPageRE: 82,
    OrderManagementPageRW: 83,
    QuotationDashboardR: 84,
    QuotationDashboardRE: 85,
    QuotationDashboardRW: 86,
    QuotationManagementPageR: 87,
    QuotationManagementPageRE: 88,
    QuotationManagementPageRW: 89,
    PersonalDashboardR: 90,
    PersonalDashboardRE: 91,
    PersonalDashboardRW: 92,
    MyDirectReportsDashboardR: 93,
    MyDirectReportsDashboardRE: 94,
    MyDirectReportsDashboardRW: 95,
    MyRequestsR: 96,
    MyRequestsRE: 97,
    MyRequestsRW: 98,
    ForApprovalR: 99,
    ForApprovalRE: 100,
    ForApprovalRW: 101,
    QuotationRequestsR: 102,
    QuotationRequestsRE: 103,
    QuotationRequestsRW: 104,
    MyCoverageR: 105,
    MyCoverageRE: 106,
    MyCoverageRW: 107,
    ReportsR: 108,
    ReportsRE: 109,
    ReportsRW: 110,
    UserGuideR: 111,
    LogOutR: 112,
    LoginR: 113,
    InventoryCircuitR: 114,
    InventoryCircuitRE: 115,
    InventoryCircuitRW: 116,
    InventoryEquipmentR: 117,
    InventoryEquipmentRE: 118,
    InventoryEquipmentRW: 119,
    InventoryASPUR: 120,
    InventoryASPURE: 121,
    InventoryASPURW: 122,
    InventoryASRR: 123,
    InventoryASRRE: 124,
    InventoryASRRW: 125,
    RequestsAllRequestsR: 126,
    RequestsAllRequestsRE: 127,
    RequestsAllRequestsRW: 128,
    RequestsMyRequestsR: 129,
    RequestsMyRequestsRE: 130,
    RequestsMyRequestsRW: 131,
    RequestsForApprovalR: 132,
    RequestsForApprovalRE: 133,
    RequestsForApprovalRW: 134,
    RequestsQuotationRequestsR: 135,
    RequestsQuotationRequestsRE: 136,
    RequestsQuotationRequestsRW: 137,
    RequestsMyCoverageR: 138,
    RequestsMyCoverageRE: 139,
    RequestsMyCoverageRW: 140,
    InvoiceDisputeDashboardR: 141,
    InvoiceDisputeDashboardRE: 142,
    InvoiceDisputeDashboardRW: 143,
    InvoiceInvoiceDashboardR: 144,
    InvoiceInvoiceDashboardRE: 145,
    InvoiceInvoiceDashboardRW: 146,
    InvoiceInvoiceUploadDashboardR: 147,
    InvoiceInvoiceUploadDashboardRE: 148,  
    InvoiceInvoiceUploadDashboardRW: 149

}